import React from "react";
import { FormikProps } from "formik";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import ATMTextField from "src/components/UI/atoms/formFields/ATMTextField/ATMTextField";
import { DueAmountFormValues } from "src/models/Dashboard.model";
import ATMDatePicker from "src/components/UI/atoms/formFields/ATMDatePicker/ATMDatePicker";
import moment from "moment";

type Props = {
  formikProps: FormikProps<DueAmountFormValues>;
  onClose: () => void;
  formType: "ADD" | "EDIT";
};

const DueAmountForm = ({ formikProps, onClose, formType }: Props) => {
  const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;
  const typeOptions = [
    { label: "Physical", value: "PHYSICAL" },
    { label: "Virtual", value: "VIRTUAL" },
  ];

  return (
    <div className="p-4 flex flex-col gap-6">
      <div className="flex justify-between items-center">
        <div className="text-xl font-medium">Update Due date</div>
        <button type="button" className="hover:bg-hover" onClick={onClose}>
          Cancel
        </button>
      </div>

      <div className="flex flex-col gap-4">
        {/* Type Selector */}
        <div>
          <ATMDatePicker
            label="Due Date "
            name="duedate"
            format="DD/MM/YYYY"
            minDate={moment().format("yyyy-MM-DD")}
            value={values.duedate || null}
            onChange={(newValue) =>
              setFieldValue("duedate", moment(newValue)?.format("yyyy-MM-DD"))
            }
          />
        </div>

        {/* Description */}
        <div>
          <ATMTextField
            name="remarks"
            value={values.remarks}
            onChange={(e) => setFieldValue("remarks", e.target.value)}
            label="Remark"
            placeholder="Enter Remark"
            onBlur={handleBlur}
          />
        </div>
      </div>

      <div>
        <ATMLoadingButton isLoading={isSubmitting} type="submit">
          Save
        </ATMLoadingButton>
      </div>
    </div>
  );
};

export default DueAmountForm;
